import React from 'react'

const CoordinateField = ({ property, name, record, ...props }) => {
  const { longitude, latitude, altitude } = record[name] || {}
  return <span>{`${latitude}, ${longitude}, ${altitude}`}</span>
}

export default CoordinateField
